module.exports = __webpack_public_path__ + "static/media/Anton.df748d5b.woff";